<template>
  <div class="app-select-array">
    <select
      ref="select"
      class="app-select-array__select"
      :value="value"
      @focus="isFocus = true"
      @blur="isFocus = false"
      @change="changed"
    >
      <option
        v-for="(item, index) in list"
        :key="`app-select-array-${index}`"
        :value="item.value"
        :disabled="item.disabled"
        class="app-select-array__option"
      >{{ `${item.label}${label}` }}</option>
    </select>
    <div
      class="app-select-array__icon"
      :class="{ 'is-focus': isFocus }"
    >
      <img
        src="@/assets/icons/icon_select_arrow.svg"
        alt=""
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 表示値
    value: {
      type: String,
      required: true
    },
    // 表示一覧
    list: {
      type: Array,
      required: false,
      default: () => [
        { value: '1', label: '1', disabled: false },
        { value: '2', label: '2', disabled: false },
        { value: '3', label: '3', disabled: true },
      ]
    },
    // 表示する単位（例：人、部屋、円...）
    label: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      isFocus: false, // selectタグがfocusされているか
    }
  },
  methods: {
    /**
     * selectに変更があったら都度valueをemitする
     */
    changed(e) {
      this.$emit('changed', e.target.value)
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.app-select-array {
  height: 100%;
  position: relative;
  width: 100%;

  &__select {
    appearance: none;
    background-color: transparent;
    border-radius: .25rem;
    cursor: pointer;
    display: block;
    height: 100%;
    padding-left: .5rem;
    width: 100%;

    @include hover {
      @include focusStyle;
    }

    @include focus {
      @include focusStyle;
    }
  }

  &__option {
    background-color: transparent;
    text-align: left;

    &:disabled {
      color: $cool-gray-4;
    }
  }

  &__icon {
    height: .75rem;
    pointer-events: none;
    position: absolute;
    right: .5rem;
    top: calc(50% - .375rem);
    transition: transform .2s;
    width: .75rem;

    &.is-focus {
      transform: rotateZ(180deg);
    }
  }
}
</style>
